'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _name = require('../name');
var _name2 = _interopRequireDefault(_name);
var _oneOf = require('../one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (titles) {
  return {
    title: (0, _oneOf2.default)(titles.map(function (title) {
      return title.value;
    }), 'Please select your title'),
    forenames: (0, _name2.default)(function (_ref) {
      var value = _ref.value;
      return value ? 'Please enter a valid first name' : 'Please enter your first name';
    }),
    surname: (0, _name2.default)(function (_ref2) {
      var value = _ref2.value;
      return value ? 'Please enter a valid surname' : 'Please enter your surname';
    })
  };
};